import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useSnackbar } from "notistack";
import { Backdrop, CircularProgress } from "@mui/material";
import {
  ContentDialog,
  ContentDialogInit,
} from "../MDDForm/components/ContentDialog.jsx";
import { Form, FormRenderer } from "../MDDForm/MDDForm.jsx";
import { useClaimCommunicationActions } from "../../hooks/useClaimCommunicationActions.jsx";

function CommunicationSubjectModal({ open, onClose, communication }) {
  const { enqueueSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = useState(false);
  const { updateCommunicationSubject } = useClaimCommunicationActions();

  const { openCD, setOpenCD, tca, setTca } = ContentDialogInit();

  useEffect(() => {
    if (!open) {
      setOpenCD(false);
      return;
    }

    const fdef = {
      formdefinition: [
        {
          control: "input",
          name: "subject",
          label: "Bezeichnung",
          cols: "12",
          valid: "isNotEmpty(item)",
        },
      ],
      transformOut: [],
    };

    setOpenCD(true);
    setTca({
      title: "Betreff bearbeiten",
      maxWidth: "sm",
      content: (
        <Form>
          <FormRenderer
            fdef={fdef}
            model={{
              id: communication?.id,
              subject: communication?.betreff || "",
            }}
            variant="filled"
            editMode={true}
            showActions={true}
            showCancel={true}
            showToggleEdit={false}
            actionsPosition="bottom"
            toggleEditPosition="top"
            showErrorText={false}
            cancelAction={onClose}
            submitAction={{
              method: "callback",
              callback: async (formData) => {
                await updateCommunicationSubject(
                  communication?.id,
                  {
                    betreff: formData?.subject,
                    schaden_id: communication?.schaden_id,
                  },
                  {
                    setIsLoading,
                    onSuccess: () => {
                      enqueueSnackbar("Betreff aktualisiert", {
                        variant: "success",
                      });
                      onClose();
                    },
                  }
                );
              },
            }}
          />
        </Form>
      ),
      actions: null,
    });
    // eslint-disable-next-line
  }, [open, communication?.id]);

  return (
    <>
      <Backdrop
        open={isLoading}
        style={{ zIndex: 1300, flexDirection: "column" }}
      >
        <CircularProgress style={{ marginBottom: 16 }} />
      </Backdrop>
      <ContentDialog
        openCD={openCD}
        setOpenCD={setOpenCD}
        tca={tca}
        onClose={onClose}
      />
    </>
  );
}

CommunicationSubjectModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  communication: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    betreff: PropTypes.string,
  }),
};

export default CommunicationSubjectModal;
